import logoSvg from '@/assets/decision-sales-os-logo.svg';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  className?: string;
}

const sizeMap = {
  sm: 'h-7 w-auto',
  md: 'h-8 w-auto',
  lg: 'h-10 w-auto',
};

export function Logo({ size = 'md', showText = true, className = '' }: LogoProps) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img 
        src={logoSvg} 
        alt="Decision Sales OS" 
        className={`${sizeMap[size]} object-contain`}
        style={{ imageRendering: 'crisp-edges' }}
      />
      {showText && (
        <span className="font-bold text-base tracking-tight text-foreground whitespace-nowrap">
          Decision Sales OS
        </span>
      )}
    </div>
  );
}
